<app-full-page-message
    *ngIf="businessId && businessId.length > 5 && !localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin)" />
<div
    *ngIf="!businessId || businessId.length <5 || localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin)">
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.payment_gateway_cust_config">
        <div>
            <div class="center" style="max-width: 800px;">
                <div [ngClass]="{'banner': wrapper.Id && wrapper.FundAccount.Id}">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="row">
                                <div class=" col-3">
                                    <button class="button_icon icon_adjust button_icon_color"
                                        (click)="onLoad()">refresh</button>
                                </div>
                                <div class="col-6">
                                    <ngx-select *ngIf="qrTypes && wrapper.Id && wrapper.FundAccount.Id"
                                        [(ngModel)]="wrapper.QrType" [allowClear]="false" [optionValueField]="'value'"
                                        [optionTextField]="'key'" [items]="qrTypes" [noAutoComplete]="true"
                                        (select)="onFocus()"
                                        placeholder="{{localService.languageContent.payment_gateway_cust_config.qr_types}}"
                                        title="{{localService.languageContent.payment_gateway_cust_config.qr_types}}">
                                    </ngx-select>
                                </div>
                                <div class="col-3">
                                    <button *ngIf="wrapper.Id && wrapper.FundAccount.Id"
                                        class="button_icon icon_adjust button_icon_color"
                                        (click)="onAction(6)">save</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="row" *ngIf="wrapper.Id && wrapper.FundAccount.Id">
                                <div class="col-6">
                                    <input autocomplete="off" [id]="elementIds.amount" type="number" class="number"
                                        [ngClass]="sampleAmount ? 'en' : ''" style="width: 100%;"
                                        [(ngModel)]="sampleAmount"
                                        placeholder="*{{localService.languageContent.payment_gateway_cust_config.amount}}"
                                        title="*{{localService.languageContent.payment_gateway_cust_config.amount}}"
                                        (keydown.enter)="onAction(5)" />
                                </div>
                                <div class="col-6">
                                    <button type="button" class="btn btn-primary" [id]="elementIds.test_qr"
                                        style="width: 100%;"
                                        (click)="onAction(5)">{{localService.languageContent.payment_gateway_cust_config.test_qr}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="banner" style="margin-top: 10px;">
                            <div class="row">
                                <div class="col-12">
                                    <div>
                                        <app-label
                                            [Text]="localService.languageContent.payment_gateway_cust_config.name"
                                            [IsMandatory]="true" />
                                    </div>
                                    <div>
                                        <input autocomplete="off" type="text" [(ngModel)]="wrapper.Name"
                                            title="{{localService.languageContent.payment_gateway_cust_config.name}}"
                                            [readOnly]="wrapper.Id"
                                            placeholder="{{localService.languageContent.payment_gateway_cust_config.name}}"
                                            id="{{elementIds.name}}" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div>
                                        <app-label
                                            [Text]="localService.languageContent.payment_gateway_cust_config.contact"
                                            [IsMandatory]="true" [IsNeedNewLine]="true" />
                                        <i class="material-icons menu_icon verify_icon" *ngIf="!wrapper.Id"
                                            [ngClass]="{'verify_success': isMobileOtpVerified}">done</i>
                                    </div>
                                    <div>
                                        <span class="en">+{{contactPrefix}}</span>
                                        <input autocomplete="off" type="number" class="en"
                                            style="text-align: left;width: calc(100% - 50px);"
                                            [(ngModel)]="wrapper.ContactNumber"
                                            title="{{localService.languageContent.payment_gateway_cust_config.contact}}"
                                            [readOnly]="wrapper.Id" [ngClass]="wrapper.ContactNumber ? 'en' : ''"
                                            (keypress)="localService.isNumberOnly($event,numericConfig)"
                                            (input)="isMobileOtpVerified = false"
                                            placeholder="{{localService.languageContent.payment_gateway_cust_config.contact}}"
                                            id="{{elementIds.contact}}" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div>
                                        <app-label
                                            [Text]="localService.languageContent.payment_gateway_cust_config.email"
                                            [IsMandatory]="true" [IsNeedNewLine]="true" />
                                        <i class="material-icons menu_icon verify_icon" *ngIf="!wrapper.Id"
                                            [ngClass]="{'verify_success': isEmailOtpVerified}">done</i>
                                    </div>
                                    <div>
                                        <input autocomplete="off" type="text" [(ngModel)]="wrapper.Email"
                                            title="{{localService.languageContent.payment_gateway_cust_config.email}}"
                                            [readOnly]="wrapper.Id" (input)="isEmailOtpVerified = false"
                                            placeholder="{{localService.languageContent.payment_gateway_cust_config.email}}"
                                            id="{{elementIds.email}}" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div>
                                        <app-label [Text]="localService.languageContent.payment_gateway_cust_config.gst"
                                            [IsMandatory]="true" [IsNeedNewLine]="true" />
                                    </div>
                                    <div>
                                        <input autocomplete="off" type="text" [(ngModel)]="wrapper.GSTIN"
                                            title="{{localService.languageContent.payment_gateway_cust_config.gst}}"
                                            [readOnly]="wrapper.Id"
                                            placeholder="{{localService.languageContent.payment_gateway_cust_config.gst}}"
                                            id="{{elementIds.gst}}" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="banner" style="margin-top: 10px;">
                            <div class="row">
                                <div class="col-12">
                                    <div>
                                        <app-label
                                            [Text]="localService.languageContent.payment_gateway_cust_config.bk_acct_num"
                                            [IsMandatory]="true" />
                                    </div>
                                    <div>
                                        <input autocomplete="off" type="password"
                                            [ngClass]="wrapper.FundAccount.BankAccountNumber == '' ? '' : 'ta'"
                                            [(ngModel)]="wrapper.FundAccount.BankAccountNumber"
                                            title="{{localService.languageContent.payment_gateway_cust_config.bk_acct_num}}"
                                            [readOnly]="wrapper.FundAccount.Id"
                                            placeholder="{{localService.languageContent.payment_gateway_cust_config.bk_acct_num}}"
                                            id="{{elementIds.bk_acct_num}}" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div>
                                        <app-label
                                            [Text]="localService.languageContent.payment_gateway_cust_config.bk_acct_num_conf"
                                            [readOnly]="wrapper.FundAccount.Id" [IsMandatory]="true"
                                            [IsNeedNewLine]="true" />
                                        <i class="material-icons menu_icon verify_icon"
                                            *ngIf="!wrapper.Id || !wrapper.FundAccount.Id"
                                            [ngClass]="{'verify_success': !(confirmAccountNumber.length == 0 || confirmAccountNumber != wrapper.FundAccount.BankAccountNumber)}">done</i>
                                    </div>
                                    <div>
                                        <input autocomplete="off" type="number" class="en" style="text-align: left;"
                                            [(ngModel)]="confirmAccountNumber"
                                            title="{{localService.languageContent.payment_gateway_cust_config.bk_acct_num_conf}}"
                                            [readOnly]="wrapper.FundAccount.Id"
                                            placeholder="{{localService.languageContent.payment_gateway_cust_config.bk_acct_num_conf}}"
                                            id="{{elementIds.bk_acct_num_conf}}" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div>
                                        <app-label
                                            [Text]="localService.languageContent.payment_gateway_cust_config.bk_acct_name"
                                            [IsMandatory]="true" [IsNeedNewLine]="true" />
                                    </div>
                                    <div>
                                        <input autocomplete="off" type="text"
                                            [(ngModel)]="wrapper.FundAccount.BankAccountName"
                                            title="{{localService.languageContent.payment_gateway_cust_config.bk_acct_name}}"
                                            [readOnly]="wrapper.FundAccount.Id"
                                            placeholder="{{localService.languageContent.payment_gateway_cust_config.bk_acct_name}}"
                                            id="{{elementIds.bk_acct_name}}" />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div>
                                        <app-label
                                            [Text]="localService.languageContent.payment_gateway_cust_config.bk_acct_ifsc"
                                            [IsMandatory]="true" [IsNeedNewLine]="true" />
                                    </div>
                                    <div>
                                        <input autocomplete="off" type="text" [(ngModel)]="wrapper.FundAccount.BankIfsc"
                                            title="{{localService.languageContent.payment_gateway_cust_config.bk_acct_ifsc}}"
                                            [readOnly]="wrapper.FundAccount.Id"
                                            placeholder="{{localService.languageContent.payment_gateway_cust_config.bk_acct_ifsc}}"
                                            id="{{elementIds.bk_acct_ifsc}}" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div style="margin-top: 10px;">
                            <span
                                style="color: red;">{{localService.languageContent.payment_gateway_cust_config.no_edit}}</span>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div style="text-align: right;margin-top: 10px;" *ngIf="!wrapper.Id || !wrapper.FundAccount.Id">
                            <button type="button" class="btn btn-primary" *ngIf="!wrapper.Id && !isMobileOtpVerified"
                                [id]="elementIds.verify_contact"
                                [disabled]="wrapper.ContactNumber.toString().length  != contactLength"
                                (click)="onAction(3)">{{localService.languageContent.payment_gateway_cust_config.verify_contact}}</button>

                            <button type="button" class="btn btn-primary"
                                *ngIf="!wrapper.Id && isMobileOtpVerified && !isEmailOtpVerified"
                                [id]="elementIds.verify_email" [disabled]="!wrapper.Email"
                                (click)="onAction(4)">{{localService.languageContent.payment_gateway_cust_config.verify_email}}</button>

                            <button type="button" class="btn btn-primary"
                                *ngIf="!wrapper.Id && isMobileOtpVerified && isEmailOtpVerified"
                                [id]="elementIds.create"
                                [disabled]="confirmAccountNumber.length == 0 || confirmAccountNumber != wrapper.FundAccount.BankAccountNumber"
                                (click)="onAction(2)">{{localService.languageContent.common.create}}</button>

                            <button type="button" class="btn btn-primary" *ngIf="wrapper.Id && !wrapper.FundAccount.Id"
                                [id]="elementIds.create"
                                [disabled]="confirmAccountNumber.length == 0 || confirmAccountNumber != wrapper.FundAccount.BankAccountNumber"
                                (click)="onAction(7)">{{localService.languageContent.payment_gateway_cust_config.save_bank}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="wrapper">
        <app-otp-container *ngIf="isShowMobileOtpPopup" [IsOtpPopup]="true" [PhNumOrEmail]="wrapper.ContactNumber"
            (onVerified)="onVerifiedOtp($event,otpType.MobileVerification)" [otpType]="otpType.RelationshipVerification"
            (onCancelled)="isShowMobileOtpPopup = false" />
        <app-otp-container *ngIf="isShowEmailOtpPopup" [IsOtpPopup]="true" [PhNumOrEmail]="wrapper.Email"
            (onVerified)="onVerifiedOtp($event,otpType.UpdateUserEmail)" [otpType]="otpType.UpdateUserEmail"
            (onCancelled)="isShowEmailOtpPopup = false" />
        <app-payment-qr-image *ngIf="wrapper.Id" [businessId]="businessId" [amount]="sampleAmount"
            [amountInputId]="elementIds.amount" [(isGenerateQr)]="isGenerateQr" [qrType]="wrapper.QrType" />
    </div>
</div>